import { qs, qsa } from '@/utils/dom';
import Swiper from "swiper";
import { Navigation, Thumbs } from "swiper/modules";
const SwiperThumb = {
    init: () => {
        const $swiperThumb = qsa('.swiper-thumb');
        if ($swiperThumb.length === 0)
            return;
        SwiperThumb.loop($swiperThumb);
    },
    loop: (elements) => {
        elements.forEach((element) => {
            const $swiperParent = qs('.swiper-parent', element);
            const $swiperChild = qs('.swiper-child', element);
            const $btnPrev = qs('.swiper-button-prev', element);
            const $btnNext = qs('.swiper-button-next', element);
            let previousIndex = 0;
            const swiperChild = new Swiper($swiperChild, {
                modules: [Thumbs],
                slidesPerView: 3,
                spaceBetween: 0,
                freeMode: true,
                watchSlidesProgress: true,
                breakpoints: {
                    640: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 8,
                    }
                },
                allowTouchMove: false,
                preventClicks: true,
                preventClicksPropagation: true,
                slideToClickedSlide: true
            });
            const swiperParent = new Swiper($swiperParent, {
                modules: [Navigation],
                loop: true,
                spaceBetween: 10,
                slidesPerView: 1.2,
                navigation: {
                    nextEl: $btnNext,
                    prevEl: $btnPrev,
                },
                thumbs: {
                    swiper: swiperChild,
                },
            });
            const swiperSlides = qsa('.swiper-slide', $swiperChild);
            swiperSlides.forEach((swiperSlide) => {
                swiperSlide.addEventListener('click', () => {
                    const { index } = swiperSlide.dataset;
                    const currentIndex = parseInt(index);
                    swiperParent.slideTo(currentIndex + 2);
                    if (currentIndex < previousIndex) {
                        swiperChild.slidePrev();
                    }
                    if (currentIndex > previousIndex) {
                        swiperChild.slideNext();
                    }
                    previousIndex = currentIndex;
                });
            });
        });
    },
};
export default SwiperThumb;
